import React, { useContext } from 'react';
import styled from 'styled-components';
import LogoAndContactLink from './LogoAndContactLink';
import TermsAndVersion from './TermsAndVersion';
import { breakpoints, sizes, theme } from '../../theme';
import NeveLearningLogoMonochrome from 'assets/icons/footer/NeveLearningLogoMonochrome';
import { NavigationLink } from 'components/Elements';
import { NEVE_LEARNING_WEBSITE_URL } from 'lib/_api-helpers';
import { AuthContext } from 'contextProviders/AuthContext';
import { RoleType } from 'models/User';

type FooterBaseProps = {
    children?: React.ReactNode;
};

export default function Footer({ children }: FooterBaseProps): JSX.Element {
    const { userData, isAuthenticated } = useContext(AuthContext);
    const learnerTheme = isAuthenticated && userData.activeRole === RoleType.LEARNER;

    return (
        <FooterBackground $learnerTheme={learnerTheme}>
            <FooterContent>
                <LeftSection>
                    <NavigationLink to={NEVE_LEARNING_WEBSITE_URL} target="_blank" $inverted>
                        <NeveLearningLogoMonochrome />
                    </NavigationLink>
                </LeftSection>
                <CenterSection>
                    <LogoAndContactLink />
                </CenterSection>
                <RightSection>{children}</RightSection>
            </FooterContent>
        </FooterBackground>
    );
}

export function ProfileFooter() {
    return (
        <Footer>
            <TermsAndVersion />
        </Footer>
    );
}

const LeftSection = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: end;
    width: 100%;

    @media (max-width: ${breakpoints.sm}) {
        justify-content: start;
    }
`;

const CenterSection = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    width: 100%;
`;

const RightSection = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    width: 100%;
`;

const FooterContent = styled.footer`
    display: flex;
    max-width: 1000px;
    width: 100%;
    padding: ${sizes.edgePadding};
    min-height: ${sizes.footerHeight};
    gap: ${sizes.spacingMd};

    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
    }
`;

const FooterBackground = styled.div<{ $learnerTheme?: boolean }>`
    background: ${({ $learnerTheme }) => ($learnerTheme ? theme.learnerFooterBackground : theme.footerBackground)};
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${sizes.footerHeight};
`;
